import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import React from 'react';

import QueryWalletBackgroundObserver from '#/api/QueryWalletBackgroundObserver';
import { captureExceptionInPosthog } from '#/lib/analyticsPosthogSetup';

/**
 * Static Query Client can be used to control the
 * react-query cache and api from outside react if
 * needed.
 *
 * Generally it is best if you use `useQueryClient()`
 *
 * @note - If using this, it must be used AFTER initial
 *         render.
 */
const staticQueryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      const errorObj =
        error instanceof Error ? error : new Error(String(error));
      console.warn(`[react-query] Query failed:`, query.queryHash, errorObj);
      captureExceptionInPosthog(errorObj, {
        reactQuery: query.queryHash,
      });
    },
  }),
  defaultOptions: {
    queries: {
      // ✅ globally default to 20 seconds
      staleTime: 1000 * 20,
    },
  },
});

export function QueryClientProviderAndHandlers({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <QueryClientProvider client={staticQueryClient}>
      <QueryWalletBackgroundObserver />
      {children}
    </QueryClientProvider>
  );
}
